export default "__VITE_ASSET__BtaSU_uD__"